import { Loader2, Sparkles } from "lucide-react";

export const Loader = ({ label = "Working…", note }) => (
  <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="loader">
    <Loader2 className="w-7 h-7 animate-spin text-blue-600" />
    <p className="mt-4 font-display text-lg font-semibold">{label}</p>
    {note && <p className="mt-1 text-sm text-slate-500 max-w-md">{note}</p>}
  </div>
);

export const Empty = ({ title, note, action }) => (
  <div className="card-flat p-10 text-center" data-testid="empty-state">
    <h3 className="font-display text-xl font-semibold">{title}</h3>
    {note && <p className="mt-2 text-sm text-slate-500 max-w-lg mx-auto">{note}</p>}
    {action && <div className="mt-6 flex justify-center">{action}</div>}
  </div>
);

export const Pill = ({ children, tone = "slate", testId }) => {
  const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    amber: "bg-amber-50 text-amber-800 border-amber-200",
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    red: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold border ${tones[tone]}`}>
      {children}
    </span>
  );
};


/** A short note from the Curriculum Advisor, in plain language. */
export const Guide = ({ children, testId = "guide-note" }) => (
  <div className="flex items-start gap-3 p-5 rounded-2xl bg-blue-50/70 border border-blue-200" data-testid={testId}>
    <Sparkles className="w-4 h-4 mt-0.5 text-blue-600 flex-none" />
    <div className="min-w-0">
      <p className="rule-label">Curriculum Advisor</p>
      <p className="mt-1.5 text-sm text-slate-700 leading-relaxed">{children}</p>
    </div>
  </div>
);
